import { WebContentState } from '@sas-dvr/internal-va-react-core/store/birdElement/webContentState';
import {
  DataDrivenContentReceiveMessage,
  DataDrivenContentSendMessage,
} from './registerDataDrivenContent';
import { ReportStore, ReportContext, getReportContext } from '../internal/ReportContext';

/**
 * @public
 */
export type DataDrivenContentConnectionOptions = {
  url: string;
  reportUri: string;
  objectName: string;
  authenticationType?: 'guest' | 'credentials';
};

/**
 * @public @sealed
 */
export class DataDrivenContentHandle {
  /**
   * @internal
   */
  private reportContext: ReportContext;
  /**
   * @internal
   */
  private store: ReportStore;
  /**
   * @internal
   */
  private objectName: string;
  /**
   * @internal
   */
  private unsubscribe: () => void;

  /**
   * @internal
   */
  constructor(
    connectionOptions: DataDrivenContentConnectionOptions,
    onMessage: (message: DataDrivenContentReceiveMessage) => void
  ) {
    this.reportContext = getReportContext({
      url: connectionOptions.url,
      reportUri: connectionOptions.reportUri,
      authenticationType: connectionOptions.authenticationType || 'credentials',
      isFullReport: false,
    }).retain();

    // Order is important here. initializeStore expects addToViewSet
    // to be called later.
    const store = this.reportContext.initializeStore(connectionOptions.objectName);
    this.reportContext.addToViewSet(connectionOptions.objectName);

    this.objectName = connectionOptions.objectName;
    this.store = store;
    let apiMessage: any = null;

    this.unsubscribe = store.subscribe(() => {
      const state = store.getState();
      if (state.birdElements) {
        const webContentState = state.birdElements.WebContent;
        if (webContentState) {
          const objectState = webContentState[connectionOptions.objectName];
          if (objectState) {
            const newMessage = objectState.messageDataPost;
            if (newMessage && newMessage !== apiMessage) {
              apiMessage = newMessage;
              onMessage({ ...apiMessage, postMessage: postMessage });
            }
          }
        }
      }
    });
  }

  dispatch(message: DataDrivenContentSendMessage): void {
    this.store.dispatch(
      WebContentState.actions.update(this.objectName, { messageDataReceive: message })
    );
  }

  deregister(): void {
    this.unsubscribe();
    this.reportContext.removeFromViewSet(this.objectName);
    this.reportContext.release();
  }
}
